// extracted by mini-css-extract-plugin
export default {"tabs":"Integration-modules__tabs__RtQBi","wrapper":"Integration-modules__wrapper__vmLvw","show-keyframe":"Integration-modules__show-keyframe__xSvto"};